import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { LeakageInformationModel } from '../../../models';

import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import { showUnit } from '../../../utils';
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const NO_OF_POLLING_TOPIC = 4;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    centralId:"",
    deviceNo: '',
    isRefreshAllCompleted: (status: number) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}

type LeakageInformationProps = {
    defaultData: LeakageInformationModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureLeakageInformationProps = LeakageInformationProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "LEAKAGE_INFORMATION_FETCH";
export const LeakageInformation_TJ360VersionDevice = (props: PureLeakageInformationProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn, centralId, deviceNo, isRefreshSuccessDeviceNo} = props;
    const { onError, onRefresh, isRefreshAllCompleted, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [leakageInformation, setLeakageInformation] = React.useState<LeakageInformationModel | null>(fetchState.data);
    const [fetchLoading, setFetchLoading] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const deviceNames = { '00': '本体', '01': '子機1', '02': '子機2', '03': '子機3', '04': '子機4' };
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PH";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            leakMa1: data.leak_ma1,
            leakMa2: data.leak_ma2,
            leakMa3: data.leak_ma3,
            leakMa4: data.leak_ma4,
            leakMa5: data.leak_ma5,
            leakMa6: data.leak_ma6,
            di1: data.di_1,
            di2: data.di_2,
            lastGetDatetime: data.last_get_datetime,
        } as LeakageInformationModel;

        setLeakageInformation(resData);
        setFetchLoading(false);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
        
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error, deviceNames[deviceNo as keyof typeof deviceNames] || '不明');
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        setFetchLoading(false);
        setIsRefreshSuccess(false);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);
    }

    const handleRefresh = () => {
        setFetchLoading(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
    };

    const handleRefreshSuccess = (data: any) => {
        handleFetchSuccess(data, true);
        props.onRefreshComplete?.();
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup === true) {
            handleRefresh();
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoading) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoading]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        if(!defaultData) {
            setLeakageInformation(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);
    return (
        <>
            {/* device00 */}
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || fetchLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title={`漏電情報`}
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流2</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流3</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流4</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流5</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流6</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>接点DI_1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>接点DI_2</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流1</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa1}{showUnit(leakageInformation?.leakMa1, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流2</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa2}{showUnit(leakageInformation?.leakMa2, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流3</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa3}{showUnit(leakageInformation?.leakMa3, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流4</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa4}{showUnit(leakageInformation?.leakMa4, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流5</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa5}{showUnit(leakageInformation?.leakMa5, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流6</td>
                                    <td style={pollingColStyle}>{leakageInformation?.leakMa6}{showUnit(leakageInformation?.leakMa6, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>接点DI_1</td>
                                    <td style={pollingColStyle}>{leakageInformation?.di1}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>接点DI_2</td>
                                    <td style={pollingColStyle}>{leakageInformation?.di2}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{leakageInformation?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            <FetchHelper fetchId={fetchId + deviceNo} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any, deviceName: string) =>
        actionCreators.showMessage({
            type: "error",
            title: `漏電情報/${deviceName}取得`,
            body: "漏電情報取得できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeakageInformation_TJ360VersionDevice);

